import apiClient from './apiClient';

// API wrapper functions for bunkering endpoints

export const bunkeringApi = {
  // List all bunkering events with optional filtering and pagination
  async getBunkerings(params = {}) {
    const { page, per_page, vessel_imo, uploaded_by, date_from, date_to } = params;
    const queryParams = new URLSearchParams();
    
    if (page) queryParams.append('page', page);
    if (per_page) queryParams.append('per_page', per_page);
    if (vessel_imo) queryParams.append('vessel_imo', vessel_imo);
    if (uploaded_by) queryParams.append('uploaded_by', uploaded_by);
    if (date_from) queryParams.append('date_from', date_from);
    if (date_to) queryParams.append('date_to', date_to);

    const url = `/bunkerings${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return apiClient.get(url);
  },

  // Get a specific bunkering event with all its documents
  async getBunkering(bunkeringId) {
    return apiClient.get(`/bunkerings/${bunkeringId}`);
  },

  // Create a new bunkering event by uploading BDN
  async createBunkering(vesselImo, bdnFile, bunkeringDate = null) {
    const formData = new FormData();
    formData.append('bdn_file', bdnFile);
    if (bunkeringDate) {
      formData.append('bunkering_date', bunkeringDate);
    }

    return apiClient.post(`/vessels/${vesselImo}/bunkerings`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
};